import React from 'react';
import { useTranslation } from 'react-i18next';
import './../scss/faq.style.scss';
import { questions } from '../constant/faq-question.constant';
import { getItem, getLocalizedPathFromLocalStorage } from '../helper/localstorage.helper';
import { useNavigate } from 'react-router-dom';
import { arrowUp, arrowDown, rightArrowBlack } from './images/svg/icons';
export const FAQSection = () => {
  const [openIndex, setOpenIndex] = React.useState(0);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isMobile = window.innerWidth < 576; // Bootstrap's mobile breakpoint

  return (
    <div className="faq-section container  text-start text-sm-center px-sm-0 padding-120 "
    >
      <h2 className="text-start text-sm-center fw-bold mb-2  Heading_h2 mx-0  w-100" >{t('FAQ_TITLE')}</h2>
      <h6 className="text-start text-sm-center mb-sm-4 mb-0 mx-0 mt-0 h6t-sm-0 pt-4  sm-heading ">
        {t('FAQ_DESCRIPTION')}
      </h6>
      <div className="faq-box rounded pt-5">
        {questions.map((item, i) => (
          <div key={i} className={`faq-item border-bottom ${i === 0 ? ' pb-3 mb-0 mb-sm-3' : ' py-3'}`}>
            <div
              className="faq-question fw-semibold d-flex justify-content-between align-items-center"
              style={{ cursor: 'pointer' }}
              onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
            >
              <div className='faq-question-item'>{t(item.q)}</div>
              <div className="faq-icon">
                {openIndex === i ? (
                  <img src={arrowUp} alt="" />

                ) : (
                  <img src={arrowDown} alt="" />
                )}
              </div>
            </div>
            {openIndex === i && item.a && (
              <div className="faq-answer mt-2 small">
                <div className='padding-left-20'>
                  {t(item.a)}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="text-start text-sm-center my-0 pt-4 mt-1">
        <button className=" px-4 py-2 border explore-btn"
          onClick={() => navigate(getLocalizedPathFromLocalStorage({ get: (key: string) => getItem(key) ?? null }, { 'sv-se': 'faq', 'en-us': 'faq' }))}

        >{isMobile ? t('READ_MORE') : t('EXPLORE_OTHER_FAQS')}
          <img src={rightArrowBlack} className="ms-1 mb-1 " alt="" style={{ marginLeft: '6px' }} />

        </button>
      </div>
    </div>
  )
}
